var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnOffOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2C15 1.44772 14.5523 1 14 1C13.4477 1 13 1.44772 13 2V13C13 13.5523 13.4477 14 14 14C14.5523 14 15 13.5523 15 13V2ZM9.83375 4.90887C10.3357 4.67852 10.5559 4.08487 10.3255 3.58291C10.0952 3.08096 9.50153 2.86078 8.99958 3.09113C4.87078 4.98588 2 9.15732 2 14.0014C2 20.6281 7.3727 26 14 26C20.6273 26 26 20.6281 26 14.0014C26 9.15732 23.1292 4.98588 19.0004 3.09113C18.4985 2.86078 17.9048 3.08096 17.6745 3.58291C17.4441 4.08487 17.6643 4.67852 18.1662 4.90887C21.6111 6.48972 24 9.96768 24 14.0014C24 19.5233 19.523 24 14 24C8.47704 24 4 19.5233 4 14.0014C4 9.96768 6.38894 6.48972 9.83375 4.90887Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnOffOutline);
export default __webpack_public_path__ + "static/media/on_off_outline.30201a6ad377bfdedb4c835d6eef74f0.svg";
export { ForwardRef as ReactComponent };